import { ADD_DRIVER, DELETE_DRIVER, GET_DRIVER, UPDATE_DRIVER ,GET_ONE_DRIVER} from "../types";
  
  const initialState = { list: [], single: null,
    pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
    },
   };
  
  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_DRIVER:
        return { ...state, list: payload.data , pagination: payload.pagination };
  
      case UPDATE_DRIVER:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_DRIVER:
        return {
          ...state,
          list: [payload, ...state.list],
        };
  
      case DELETE_DRIVER:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
        };

      case GET_ONE_DRIVER:
        return { ...state, single: payload };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  